export const stringOrNull = (value?: string | null) => {
  return value?.length ? value : null
}
